// Every service, most popular first: by how widely used it is, checked
// against what people connect most on the platform. Keyed by service, so a
// vendor's sign-in and its blocks rank together. A service missing from this
// list sorts after all of them, A to Z.
export const POPULAR_SERVICE_IDS = [
  "google",
  "github",
  "slack",
  "notion",
  "linear",
  "discord",
  "twitter",
  "hubspot",
  "airtable",
  "openai",
  "anthropic",
  "atlassian",
  "stripe",
  "reddit",
  "telegram",
  "todoist",
  "zapier",
  "canva",
  "paypal",
  "microsoft_365_copilot",
  "calendly",
  "monday",
  "wordpress",
  "google_maps",
  "medium",
  "cloudflare",
  "intercom",
  "intercom_eu",
  "miro",
  "webflow",
  "sentry",
  "posthog",
  "elevenlabs",
  "replicate",
  "open_router",
  "groq",
  "nvidia",
  "ollama",
  "http",
  "smtp",
  "generic_webhook",
  "mcp",
  "database",
  "amplitude",
  "apollo",
  "gong",
  "brevo",
  "customer_io",
  "customer_io_eu",
  "clay",
  "coda",
  "granola",
  "apify",
  "firecrawl",
  "tavily",
  "exa",
  "pinecone",
  "mem0",
  "fal",
  "ideogram",
  "d_id",
  "wolfram",
  "openweathermap",
  "chargebee",
  "brex",
  "aws_databases",
  "azure_cosmos_db",
  "appwrite",
  "langfuse",
  "sourcegraph",
  "tabnine",
  "context7",
  "v0",
  "composio",
  "algolia_productivity",
  "llama_api",
  "aiml_api",
  "jina",
  "stagehand",
  "e2b",
  "ayrshare",
  "agent_mail",
  "smartlead",
  "dataforseo",
  "screenshotone",
  "bannerbear",
  "unreal_speech",
  "revid",
  "zerobounce",
  "webshare_proxy",
  "infobip",
  "bird",
  "datarobot",
  "arize",
  "atlan",
  "atlassian_forge",
  "mobbin",
  "craft",
  "plain",
  "harmonic",
  "crustdata",
  "enrichlayer",
  "dataforb2b",
  "amplemarket",
  "anysearch",
  "parallel",
  "stripe_link",
  "slant3d",
  "1inch",
  "aave",
  "allquiet",
  "ando",
  "antimetal",
  "baas",
  "compass",
  "conductor",
  "context_dev",
  "gojiberry_ai",
  "opsera",
  "openseo",
  "rmfg",
  "runlayer",
  "subtext",
  "superme",
  "treg",
  "typesafe",
  "wonder",
];
